// collaboration-tabs v1: Collaboration Tab 切換組件

import React from 'react';

/**
 * Collaboration Tab 切換組件
 * @param {string} activeTab - 當前選中的 tab ('published' | 'drafts')
 * @param {Function} onTabChange - Tab 切換事件處理函數
 * @param {string} className - 額外的 CSS 類名
 */
const CollaborationTabs = ({ activeTab, onTabChange, className = '' }) => {
  return (
    <div className={`border border-black rounded-lg p-1 ${className}`}>
      <div className='flex bg-transparent rounded-md'>
        <button
          onClick={() => onTabChange('published')}
          className={`flex-1 py-2 px-4 text-sm font-bold rounded-md transition-colors duration-200 ${
            activeTab === 'published'
              ? 'bg-black text-white'
              : 'border border-black text-black hover:bg-purple-500 hover:text-white'
          }`}
        >
          Published
        </button>
        <button
          onClick={() => onTabChange('drafts')}
          className={`flex-1 py-2 px-4 text-sm font-bold rounded-md transition-colors duration-200 ${
            activeTab === 'drafts'
              ? 'bg-black text-white'
              : 'border border-black text-black hover:bg-purple-500 hover:text-white'
          }`}
        >
          Drafts
        </button>
      </div>
    </div>
  );
};

export default CollaborationTabs;
